export default __webpack_public_path__ + "static/media/annex4.ea2014e2.png";